import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockIssueService = {
    getStockIssueList,
    getAllStockIssueList,
    saveStockIssue,
    printStockIssueInvoice,
    exportStockIssueExcel,
    exportAllStockIssueExcel,
    getStockIssueExcelTemplate,
    saveStockIssueExcel
}

function getAllStockIssueList(searchParams) {
    let params = {
        sort: "warehouseName,asc"
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }    

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    return axios.get("/auth/stock-issues", { params });
}

function getStockIssueList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    return axios.get("/auth/stock-issues", { params });
}

function saveStockIssue(stockIssue) {
    return axios.post("/auth/stock-issue", stockIssue);

}

function printStockIssueInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/print-stock-issue-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function exportStockIssueExcel(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/stock-issue-excel/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
function exportAllStockIssueExcel(searchParams) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/stock-issue-header-detail-excel/",
        method: "GET",
        responseType: "arraybuffer", // important
        params: {
            warehouseId: searchParams.warehouseId,
            fromDate: searchParams.fromDate,
            toDate: searchParams.toDate,
            issueNo: searchParams.issueNo,
            serialNo: searchParams.serialNo,
            updateUserId: searchParams.updateUserId,
        },
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
function getStockIssueExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-issue-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function saveStockIssueExcel(file) {
    return axios.post('/auth/stock-issue-excel',
        file, {
        headers: {
            'Content-Type': 'multpart/form-data'
        }
    })
}
